/* eslint-disable */
import { Middleware, MiddlewareSync } from "@sa/rep-common";
import { DataFlowProcessingState, ComponentContextProcessingState } from "@sa/rep-core";
import { ContextReport1 } from "../Context";
import { REPORT_ID, REPORT_APE_ID } from '../constants';
import { ComponentContextCreateOptionsBasf } from "../../../shared";
import { dataSourcesService } from "../../../dataFlow";

export const report8ContextsMiddleware: MiddlewareSync<ComponentContextProcessingState> = (input, next) => {
  if (REPORT_APE_ID === input.identification.reportId || REPORT_ID === input.identification.reportId) {
    const options = input.createOptions as ComponentContextCreateOptionsBasf;
    if (options) {
      options.dataSourcesService = dataSourcesService;
    }
    const context = new ContextReport1(input.identification.componentId, options);
    input.componentContext = context;
  }
  return next(input);
};
